import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Typography } from '@material-ui/core';
import { green, red } from '@material-ui/core/colors';

import withAuth from '../../consumers/withAuth';
import api from '../../services/api';
import DataCard from '../../components/DataCard/DataCard';


const styles = () => ({
  successText: {
    color: green[600],
  },
  errorText: {
    color: red[600],
  },
});

const propTypes = {
  classes: PropTypes.oneOfType([PropTypes.object]).isRequired,
  url: PropTypes.string.isRequired,
};


class BrokenLinks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        internals: 0,
        externals: 0,
        total: 0,
      },
      loading: true,
      empty: true,
    };
    this.fetchData = this.fetchData.bind(this);
  }

  componentWillMount() {
    this.fetchData();
  }

  async fetchData() {
    const { url, auth } = this.props;
    try {
      const brokenLinks = await api.report.getBrokenLinks(url, auth.getToken());
      // eslint-disable-next-line
      const { data: { data: { internals, externals, total_number } } } = brokenLinks;
      this.setState({
        data: { internals, externals, total: total_number },
        loading: false,
        empty: false,
      });
    } catch (error) {
      const { response: { status } } = error;
      this.setState({ loading: false, empty: true });
      if (status === 401) {
        auth.logout();
      }
    }
  }

  render() {
    const { classes } = this.props;
    const { data, loading, empty } = this.state;
    const { internals, externals, total } = data;
    return (
      <DataCard
        title="Broken Links"
        loading={loading}
        empty={empty}
      >
        <Grid
          spacing={32}
          container
          alignItems="center"
          justify="center"
        >
          <Grid sm={4} md={4} item>
            <Typography variant="h4" className={internals > 0 ? classes.errorText : classes.successText} gutterBottom>
              {internals}
            </Typography>
            <Typography variant="overline" gutterBottom>
              Internal
            </Typography>
          </Grid>
          <Grid sm={4} md={4} item>
            <Typography variant="h4" className={externals > 0 ? classes.errorText : classes.successText} gutterBottom>
              {externals}
            </Typography>
            <Typography variant="overline" gutterBottom>
              External
            </Typography>
          </Grid>
          <Grid sm={4} md={4} item>
            <Typography variant="h4" className={total > 0 ? classes.errorText : classes.successText} gutterBottom>
              {total}
            </Typography>
            <Typography variant="overline" gutterBottom>
              Total
            </Typography>
          </Grid>
        </Grid>
      </DataCard>
    );
  }
}


BrokenLinks.propTypes = propTypes;
export default withStyles(styles, { withTheme: true })(withAuth(BrokenLinks));
